'use strict';

export const ADD_ERROR = 'errors/ADD_ERROR';
export const REMOVE_ERROR = 'errors/REMOVE_ERROR';
export const QUEUE_REMOVE = 'errors/QUEUE_REMOVE';
export const REMOVE_ALL = 'errors/REMOVE_ALL';
